import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.css'; // dx.light.css
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
// import 'primeicons/primeicons.css';

import "viewerjs/dist/viewer.css";
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueRouter from "vue-router";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import store from "@/state/store";
import App from "./App.vue";
import i18n from "@/utils/i18n";
import { Table, Datepicker, Tabs, Slider } from 'buefy';
import JsonExcel from "vue-json-excel";
import Toast from "vue-toastification";
import moment from 'vue-moment';
import momentTimezone from 'moment-timezone'
import Collapsible from 'vue-collapsible-component';
import BootstrapVueTreeview from 'bootstrap-vue-treeview'
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import ImageUploader from 'vue-image-upload-resize';
import titleMixin from './utils/mixins/titleMixin';
import DatePicker from "vue2-datepicker";
import ar from 'date-format-parse/lib/locale/en';
const currentLang = store.getters['i18N/getLanguage'];

const lang = {
  formatLocale: {
    ...ar,
    meridiem: (hour) => hour < 12 ? 'صباحًا' : 'مساءً',
    meridiemParse: /صباحًا|مساءً/,
    weekdaysMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    monthsShort: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']  
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true,
};

if (currentLang === "ar") DatePicker.locale('ar', lang);
import VueTimepicker from 'vue2-timepicker'
import Multiselect from "vue-multiselect";
import Viewer from "v-viewer";
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import { MdTable, MdContent, MdRipple, MdField, MdButton, MdSwitch } from 'vue-material/dist/components'
import 'vue2-timepicker/dist/VueTimepicker.css'
// import { defineAsyncComponent } from 'vue'
import VpInput from "@/components/sharedComponents/form/Input.vue"
import VpMultiselect from "@/components/sharedComponents/form/Multiselect.vue"
import VpTreeselect from "@/components/sharedComponents/form/Treeselect.vue"
import VpTextarea from "@/components/sharedComponents/form/Textarea.vue"
import VpSwitch from "@/components/sharedComponents/form/Switch.vue"
import VpPageLoader from "@/components/sharedComponents/PageLoader.vue"
import VpMassActionTable from "@/components/sharedComponents/massaction/Table.vue"
import VpEditor from "@/components/sharedComponents/form/Editor.vue"
import VpQuillEditor from "@/components/sharedComponents/form/QuillEditor.vue"
import VpDatepicker from "@/components/sharedComponents/form/Datepicker.vue"
import VpFormModal from "@/components/sharedComponents/form/FormModal.vue"
import Editor from '@tinymce/tinymce-vue';
import GlobalConfirmationModal from '@/components/sharedComponents/GlobalConfirmationModal.vue';
import GlobalButton from '@/components/sharedComponents/form/GlobalButton.vue';
import GlobalFormLayout from '@/components/sharedComponents/GlobalFormLayout.vue';
import PrimeVue from 'primevue/config';
import RadioButton from 'primevue/radiobutton';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

// socket.io
import VueSocketio from 'vue-socket.io';

Vue.use(new VueSocketio({
  // debug: true,
  connection: process.env.VUE_APP_GRID_SYNC_URL,
  vuex: {
    store,
    actionPrefix: "SOCKET_",
    mutationPrefix: "SOCKET_"
  }
})
);

// import the styles
import 'vue-collapsible-component/lib/vue-collapsible.css';
import "vue-toastification/dist/index.css";
import "@/design/index.scss";
import 'vue-material/dist/vue-material.min.css'
import devExtremeMessages from '@/utils/locales/devextreme.js';
import { locale, loadMessages } from "devextreme/localization";

loadMessages(devExtremeMessages);
locale(currentLang);

//Global components
Vue.component('VpPageLoader', VpPageLoader)

//Form components
Vue.component('VpInput', VpInput)
Vue.component('VpMultiselect', VpMultiselect)
Vue.component('VpTextarea', VpTextarea)
Vue.component('VpSwitch', VpSwitch)
Vue.component('VpTreeselect',VpTreeselect)
Vue.component('editor',Editor)
Vue.component('VpEditor',VpEditor)
Vue.component('VpQuillEditor',VpQuillEditor)
Vue.component('VpConfirmModal', GlobalConfirmationModal);
Vue.component('VpButton', GlobalButton);
Vue.component('VpFormLayout', GlobalFormLayout);
Vue.component('VpDatepicker',VpDatepicker)
Vue.component('VpFormModal',VpFormModal)

//Mass action
Vue.component('VpMassActionTable', VpMassActionTable)

Vue.use(VueRouter);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Toast);
Vue.use(moment, {
  momentTimezone
});
Vue.use(Collapsible);
Vue.use(BootstrapVueTreeview);
// buefy components
Vue.use(Table);
Vue.use(Datepicker);
Vue.use(DatePicker);
Vue.use(VueTimepicker);
Vue.component('multiselect', Multiselect);
Vue.use(Tabs);
Vue.use(Slider);
Vue.use(Vuelidate);
Vue.use(require("vue-chartist"));
Vue.use(VueTextareaAutosize);
Vue.use(ImageUploader);
Vue.use(Viewer);
Vue.use(PerfectScrollbar);
Vue.use(MdTable);
Vue.use(MdContent);
Vue.use(MdRipple);
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdSwitch);
Vue.use(PrimeVue);
Vue.component('RadioButton', RadioButton);
Vue.component("downloadExcel", JsonExcel);
Vue.component('VueQrcode', VueQrcode);
Vue.mixin(titleMixin);
Vue.use(Vuetify);

// Configure Vuetify with MDI as the default icon font
const vuetify = new Vuetify({
  options: {
    customProperties: true
  },
  icons: {
    iconfont: 'mdi', // Specify MDI as the default icon font
  },
  theme: {
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  },
});

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
